import React, { useEffect, useState } from "react";
import { Box, LinearProgress, Accordion, AccordionSummary, AccordionDetails, Typography, Chip, Grid, Card, CardContent } from "@mui/material";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import bkstApi from "../../common/component/api";
import { useParams } from "react-router-dom";
import { capitalize, getSizeChartByProductType } from "../../common/component/util";
import { ExpandMoreOutlined } from "@mui/icons-material";
import CatalogSizeVariantGrid from "./CatalogSizeVariantGrid";

export default function BakerConfig(props) {
  const { bakerId } = useParams();
  const { sizeChart } = props;

  const [config, setConfig] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    bkstApi.get(`/baker/${bakerId}/config`).then((res) => {
      setConfig(res.data.config);
      setLoading(false);
    });
  }, [bakerId]);

  const handleSubmit = (configKey, payload) => {
    console.log("payload", payload);
    bkstApi.put(`/baker/${bakerId}/config/${configKey}`, payload).then((res) => {});
  };

  if (loading) {
    return <LinearProgress />;
  } else {
    return (
      <Box my={4}>
        {config &&
          typeof config === "object" &&
          Object.keys(config).map((key, idx) => (
            <Accordion key={idx} elevation={0} sx={{ border: "1px solid #DEDEDE" }}>
              <AccordionSummary expandIcon={<ExpandMoreOutlined />}>{capitalize(key)}</AccordionSummary>
              <AccordionDetails>
                {key === "catalog" ? (
                  <Box>
                    {config[key] && typeof config[key] === "object" && Object.keys(config[key]).length > 0 ? (
                      <Box>
                        {Object.entries(config[key])
                          .sort(([, a], [, b]) => {
                            const aCount = a.variants ? Object.keys(a.variants).length : 0;
                            const bCount = b.variants ? Object.keys(b.variants).length : 0;
                            return bCount - aCount;
                          })
                          .map(([productType, productConfig]) => (
                            <Box sx={{ mb: 2 }}>
                              <Box key={productType} sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
                                <Typography variant="h6">
                                  {productConfig.name} ({productConfig.variants && Object.keys(productConfig.variants).length} variants)
                                </Typography>
                              </Box>
                              <Box sx={{ mt: 2 }}>
                                {productConfig.variants &&
                                  Object.entries(productConfig.variants)
                                    .sort(([, a], [, b]) => (b.rank ?? 0) - (a.rank ?? 0))
                                    .map(([variantKey, variantData]) => (
                                      <Box key={variantKey}>
                                        <Accordion elevation={0} sx={{ border: "1px solid #DEDEDE" }}>
                                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                            <Box>
                                              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                <Typography variant="subtitle1">{variantData.name}</Typography>
                                                <Typography variant="overline" color="text.secondary">
                                                  • {variantData.field?.type} ({variantData.field.min}-{variantData.field.max}) •{" "}
                                                  {variantData.field?.options.length} options
                                                </Typography>
                                              </Box>
                                              {variantData.required && <Chip label="Required" size="small" variant="outlined" color="secondary" />}
                                              <Chip label={`Rank: ${variantData.rank}`} size="small" variant="outlined" color="secondary" />
                                            </Box>
                                          </AccordionSummary>
                                          <AccordionDetails>
                                            <CatalogSizeVariantGrid
                                              catalog={config[key]}
                                              productType={productType}
                                              variantType={variantKey}
                                              sizeChart={config[key][productType].variants.size.field.options}
                                              options={variantData.field?.options}
                                              handleSubmit={(payload) => handleSubmit(key, payload)}
                                            />
                                          </AccordionDetails>
                                        </Accordion>
                                      </Box>
                                    ))}
                              </Box>
                            </Box>
                          ))}
                      </Box>
                    ) : (
                      <Box>
                        <Typography variant="body1" color="text.secondary">
                          No catalog data available
                        </Typography>
                      </Box>
                    )}
                  </Box>
                ) : (
                  <pre style={{ fontSize: "10px", color: "#FFF", backgroundColor: "#000", textAlign: "left" }}>
                    {JSON.stringify(config[key], null, 2)}
                  </pre>
                )}
              </AccordionDetails>
            </Accordion>
          ))}
      </Box>
    );
  }
}
